import { useState, useEffect } from 'react';
import { apiGet, apiPut } from './api';

/**
 * Charge la valeur d'un paramètre global du site depuis /site-settings/:key.
 * Retourne { value, loading, error, refetch }.
 */
export function useSiteSetting(key: string) {
  const [value, setValue] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetch = () => {
    setLoading(true);
    apiGet(`/site-settings/${key}`)
      .then((d) => setValue(d.value ?? null))
      .catch(() => setError('Erreur de chargement'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetch(); }, [key]);

  return { value, loading, error, refetch: fetch };
}

/**
 * Sauvegarde un setting global via PUT /site-settings/:key (admin seulement).
 */
export async function saveSiteSetting(key: string, value: string, label?: string, description?: string) {
  return apiPut(`/site-settings/${key}`, { value, label, description });
}
